<div class="fresh-ui">
    <div class="modal-header">
        <label class="mb-0">
            Filters
        </label>
        <button type="button" class="close" (click)="closeModal()">
            <svg width="16" height="16" viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5305 0.47083C15.0733 0.0136297 14.3329 0.0136297 13.8757 0.47083L8.00173 6.34603L2.12533 0.47083C1.66813 0.0136297 0.92893 0.0136297 0.47173 0.47083C0.0133297 0.92803 0.0133297 1.66843 0.47173 2.12563L6.34693 8.00083L0.47173 13.876C0.0133297 14.3332 0.0133297 15.0712 0.47173 15.5284C0.70093 15.7588 0.99973 15.8716 1.29973 15.8716C1.59853 15.8716 1.89733 15.7588 2.12533 15.5284L8.00173 9.65563L13.8757 15.5284C14.1049 15.7588 14.4037 15.8716 14.7025 15.8716C15.0025 15.8716 15.3025 15.7588 15.5305 15.5284C15.9877 15.0712 15.9877 14.3332 15.5305 13.876L9.65533 8.00083L15.5305 2.12563C15.9877 1.66843 15.9877 0.92803 15.5305 0.47083Z"
                    fill="#2f2f2f"></path>
            </svg>
        </button>
    </div>
    <div class="modal-body modal-body-filter">
        <div class="mobile-modal">
            <div class="filters-sidebar filters-mobile">
                <div class="fs-title">
                    {{categoryName}}
                </div>
                <div class="filter-list-card"
                    *ngFor="let subCategoryDataItem of videoCategoryData">
                    <label class="mb-0">
                        <input type="checkbox"
                            [value]="subCategoryDataItem.Id"
                            [checked]="subCategoryDataItem?.IsSelected"
                            (change)="toggleSelection(subCategoryDataItem)">
                        {{ subCategoryDataItem?.Name }}
                    </label>
                </div>

                <div class="fs-title mt-5">
                    Sort by
                </div>
                <div class="filter-list-card"
                    *ngFor="let sortByItem of soryByData"
                    (click)="setSortFilter(sortByItem)">
                    {{sortByItem.Name}}
                </div>

                <div class="fs-title mt-5">
                    Photo
                </div>
                <div class="filter-list-card"
                    *ngFor="let photoItem of photoFilterData"
                    (click)="setPhotoFilter(photoItem)">
                    {{photoItem.Name}}
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer justify-content-between">
        <a class="btn-247 btn-small btn-primary-main" (click)="closeModal()">
            View results
        </a>
    </div>
</div>